export default {
    created () {
        window.addEventListener('beforeunload', (event) => {
            if (this.isSheetChanged) {
                event.returnValue = window.confirm(this.$t('message.leave_confirmation'));
            }
        });
    },
    computed: {
        isSheetChanged () {
            return Object.keys(this.fields).some(
                (key) => this.fields[key].changed && this.fields[key].touched
            );
        }
    },
    beforeRouteLeave (from, to, next) {
        if (this.isSheetChanged && !this.$store.getters['token/isForcedToLogout']) {
            this.$refs.confirm.dialog = true;
            this.$refs.confirm.open().then((confirm) => {
                if (confirm) {
                    this.$store.commit('audit/clearComment');
                    Object.keys(this.$validator.flags).forEach((x) => {
                        this.$validator.flags[x].changed = false;
                    });
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            this.$store.commit('audit/clearComment');
            next();
        }
    }
};
